import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import type { assignee_softwareReleasesVersionDetailIssueList$key } from '@atlassian/jira-relay/src/__generated__/assignee_softwareReleasesVersionDetailIssueList.graphql';
import messages from './messages.tsx';

type Props = {
	jiraAssigneeField: assignee_softwareReleasesVersionDetailIssueList$key;
};

export const Assignee = ({ jiraAssigneeField }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const data = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment assignee_softwareReleasesVersionDetailIssueList on JiraSingleSelectUserPickerField {
				user {
					picture
					name
				}
			}
		`,
		jiraAssigneeField,
	);

	const avatarUrl = data?.user == null ? '' : data.user.picture;
	const displayName = data?.user == null ? formatMessage(messages.unassigned) : data.user.name;

	return (
		<AssigneeContainer>
			<Tooltip content={displayName} position="bottom-start">
				<VerticalCenter>
					<Avatar appearance="circle" src={avatarUrl} size="small" />
				</VerticalCenter>
			</Tooltip>
		</AssigneeContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AssigneeContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	height: '32px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& > :not(:last-child)': {
		marginRight: token('space.100'),
	},
	width: '32px',
	minWidth: '32px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const VerticalCenter = styled.div({
	display: 'flex',
	alignItems: 'center',
});
